import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

const SocialBtn = styled(Button)({
  padding: '0',
  border: 'none',
  minWidth: 'auto',
  '& svg': {
    color: '#AB9178',
  },
  '&:hover svg': {
    fill: '#725A4A',
  },
  '&+div': {
    marginLeft: '5px',
  },
});

export default SocialBtn;
